import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M10.033 8.85s2.011-5.21 3.62-4.891.855 4.944.553 5.954c-.251 1.01 5.128.054 5.58 1.968.453 1.914.503 6.912-3.167 7.071-3.57.16-7.032.425-8.949-1.754-1.916-2.18-1.81-4.573-.955-5.849.704-1.063 4.022-.532 3.067 1.382-.955 1.915-4.726 2.606-5.782-1.063"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M16.62 18.952c-3.57.16-7.033.425-8.95-1.754-1.916-2.18-1.81-4.573-.955-5.849.704-1.063 4.022-.532 3.067 1.382-.955 1.915-4.726 2.606-5.782-1.063"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const RecommendIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
